import type { UspCardContent } from '../data/types'

// Fixed by grid position, identical on every industry page — see
// .claude/rules/unimo-design-system.md. Not tied to copy order.
const HUE_BY_POSITION = ['turquoise', 'pink', 'orange', 'blue'] as const

const GRADIENT_CLASS: Record<(typeof HUE_BY_POSITION)[number], string> = {
    turquoise: 'from-unimo-site-turquoise-light',
    pink: 'from-unimo-site-pink-light',
    orange: 'from-unimo-site-orange-light',
    blue: 'from-unimo-site-blue-light',
}

interface UspCardProps extends UspCardContent {
    position: 0 | 1 | 2 | 3;
}

// Proportions, internal padding and icon placement measured directly from
// design/USP lock up spacing.svg (592.3×349.4 per card — landscape, not
// square). Icon sits at its own native aspect ratio, sized relative to the
// card, top-right; copy is bottom-anchored. Gradient runs from the hue's
// Light tone in the top-right corner, diagonally down to Stone bottom-left.
//
// The aspect ratio is desktop-only (md:aspect-[592/349]) — locking it on a
// narrow mobile column makes the card too short for the body copy to fit
// without clipping. Mobile grows to fit its content instead, with a fixed
// icon height rather than the height-percentage sizing the locked aspect
// ratio enables at md+.
export function UspCard({ title, body, icon, position }: UspCardProps) {
    const hue = HUE_BY_POSITION[position]

    return (
        <div className={`relative flex flex-col overflow-hidden rounded-site-card bg-gradient-to-bl ${GRADIENT_CLASS[hue]} to-unimo-stone p-8 md:aspect-[592/349]`}>
            <img src={icon} alt="" aria-hidden="true" className="ml-auto h-20 w-auto object-contain md:h-[45%]" />
            <div className="mt-4 md:mt-auto">
                <h3 className="text-xl font-medium text-unimo-slate">{title}</h3>
                <p className="mt-2 font-light text-unimo-slate">{body}</p>
            </div>
        </div>
    )
}

export default UspCard
